export default {
  'monetization_revenue_Revenue': 'Revenue',
  'monetization_revenue_Revenue($)': 'Revenue({unit})', // 1
  'monetization_revenue_Revenue_Trends': 'ARPU & ARPPU',// 2
  'monetization_revenue_Payer_And_Payer%': 'Payer And Payer%', // 5
  'monetization_revenue_Revenue_Channel_Distribution': 'Revenue Channel Distribution', // 8
  'monetization_revenue_ARPU': 'ARPU', // 3
  'monetization_revenue_ARPPU': 'ARPPU', // 4
  'monetization_revenue_Payer': 'Payer', // 6
  'monetization_revenue_Payer%': 'Payer%', // 7

  // Country/Region/Zone Breakdown 模块
  'monetization_revenue_Country/Region/Zone_Breakdown': 'Country/Region/Zone Breakdown', // 1
  'monetization_revenue_Country': 'Country',
  'monetization_revenue_Region': 'Region',
  'monetization_revenue_Zone': 'Zone',
  'monetization_revenue_Countries': 'Countries',
  'monetization_revenue_Regions': 'Regions',
  'monetization_revenue_Zones': 'Zones',
  'monetization_revenue_Share_Of_All': 'Share of All', // 14
  'monetization_revenue_Revenue_of_top_10_Countries': 'Revenue of top 10 Countries', // 11
  'monetization_revenue_Revenue_of_top_10_Regions': 'Revenue of top 10 Regions', // 11
  'monetization_revenue_Revenue_of_top_10_Zones': 'Revenue of top 10 Zones', // 11

  'monetization_revenue_DAU': 'DAU', // 5
  'monetization_revenue_WAU': 'WAU', // 5
  'monetization_revenue_MAU': 'MAU', // 5
  'monetization_revenue_ARPPU($)': 'ARPPU({unit})', // 7
  'monetization_revenue_ARPU($)': 'ARPU({unit})', // 8
  'monetization_revenue_Avg': 'Avg.', //
  'monetization_revenue_Sum': 'Sum ', // 4
  'monetization_revenue_Revenue_Country_Distribution': 'Revenue Country Distribution', // 12
  'monetization_revenue_Revenue_Region_Distribution': 'Revenue Region Distribution', // 12
  'monetization_revenue_Revenue_Zone_Distribution': 'Revenue Zone Distribution', // 12
  'monetization_revenue_Avg.Revenue($)': 'Avg.Revenue({unit})', // 5


  'monetization_revenue_Share': 'Share',
  'monetization_revenue_Date': 'Date',

  'monetization_revenue_Overall_Payment': 'Overall Payment',
  'monetization_revenue_Total_Revenue($)': 'Total Revenue({unit})',

  'monetization_revenue_ARPP': 'ARPP', // 3
  'monetization_revenue_Payer%(new users)': 'Payer%(new users)', //
  'monetization_revenue_New_Payer': 'First-time Payer', //
  'monetization_revenue_Revenue(new_users)': 'Revenue(first-time payer)', //
  'monetization_revenue_New_users_ARPPU($)': 'First-time Payer ARPPU({unit})', //
  'monetization_revenue_New_users_ARPU($)': 'New users ARPU({unit})', //
  'monetization_revenue_Total_Pay_Days': 'Total Pay Days', //
  
}
